const initial = {
  Minicart: {}
};

export default function minicart(state = initial, action) {
  switch (action.type) {
    case 'MINICART_DATA':
      return {
        ...state,
        Minicart: action.miniCartData
      };

    default:
      return state;
  }
}
